<template>
  <v-flex xs12 sm6 md3 :class="paddingClass">
    <v-autocomplete
      v-model.trim="userId"
      :search-input.sync="search"
      cache-items
      :autofocus="false"
      :loading="isLoading"
      :items="users"
      item-text="value"
      item-value="id"
      placeholder="Wpisz imię i/lub nazwisko"
      hide-no-data
      clearable
      flat
      label="Imię i nazwisko"
    ></v-autocomplete>
  </v-flex>
</template>

<script>
import { getUserFilterList } from '../../../repository/users/index';

export default {
  name: 'filter-by-user',
  data: () => ({
    userId: null,
    users: [],
    search: null,
    isLoading: false,
    descriptionLimit: 60,
  }),
  computed: {
    paddingClass() {
      return this.$vuetify.breakpoint.xs ? 'pr-0' : 'pr-3';
    },
  },
  methods: {
    async getFilterList(searchValue) {
      this.isLoading = true;
      try {
        const usersFilterList = await getUserFilterList({ name: searchValue });
        this.isLoading = false;
        this.users = usersFilterList.data.data.items;
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.getFilterList();
  },
  watch: {
    search(val) {
      const isInList = this.users.find(item => item.value === val);
      if (val && !isInList) {
        this.getFilterList(val);
      }
    },
    userId(id) {
      const { query } = this.$route;
      const newQuery = {
        ...query,
      };
      if (id) {
        newQuery.user_id = id;
      } else {
        delete newQuery.user_id;
      }
      this.$router.push({ path: '/uzytkownicy/1', query: newQuery });
    },
  },
};
</script>
